var map = {
	"./casino/lang/en/home/home.lang.json": "p0QM",
	"./casino/lang/en/home/welcome.lang.json": "f8GC",
	"./casino/lang/en/template/menu.lang.json": "g+5H",
	"./casino/lang/en/user/home.lang.json": "Xm/y",
	"./casino/lang/en/user/notifications.lang.json": "tM2h",
	"./casino/lang/en/user/products/requests.lang.json": "eTfT",
	"./casino/lang/en/user/register.lang.json": "ypOa",
	"./casino/lang/en/user/user.lang.json": "1WX6",
	"./casino/lang/fr/home/home.lang.json": "MxWT",
	"./casino/lang/fr/home/welcome.lang.json": "+SAS",
	"./casino/lang/fr/template/menu.lang.json": "MSdH",
	"./casino/lang/fr/user/home.lang.json": "ZPBS",
	"./casino/lang/fr/user/notifications.lang.json": "scmz",
	"./casino/lang/fr/user/products/requests.lang.json": "M2VS",
	"./casino/lang/fr/user/register.lang.json": "Z8ju",
	"./casino/lang/fr/user/user.lang.json": "pgFu",
	"./default/lang/en/home/template.lang.json": "XIXS",
	"./default/lang/fr/home/template.lang.json": "TChs",
	"./marketmaker/lang/en/home/template.lang.json": "s7CP",
	"./marketmaker/lang/fr/home/template.lang.json": "/zrn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "k+dR";


//////////////////
// WEBPACK FOOTER
// ./src/companies ^\.\/.*\.lang\.json$
// module id = k+dR
// module chunks = 1